import React from 'react';
import { Swiper, SwiperSlide, } from "swiper/react";
import { Link } from "react-router-dom";
import { Autoplay } from "swiper";
import { calculateDiscountPercentage } from '../helpers/helpers';

import "swiper/css";

const SwiperCTNProducts = (props) => {
    // Verifica se deve centralizar
    const centralizar = props.products.length <= 2;

    // Função para obter a quantidade do produto no carrinho
    const getQtd = (Data) => {
        if (typeof props.getQtdInCart === 'function') {
            return props.getQtdInCart(Data.id) || 0;
        }
        return 0;
    };

	return (
		<>
			<Swiper className="mySwiper-2"
				style={centralizar ? { display: 'flex', justifyContent: 'center' } : {}}
				speed={8000}
				slidesPerView={5}
				spaceBetween={20}
				autoplay={{
					delay: 1200,
				}}
				modules={[Autoplay]}
				breakpoints={{
					360: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					600: {
						slidesPerView: 3,
						spaceBetween: 20,
					},
					700: {
						slidesPerView: 4,
						spaceBetween: 20,
					}
					,
					1200: {
						slidesPerView: 3,
						spaceBetween: 20,
					},
					1920: {

						slidesPerView: 5,
						spaceBetween: 20,
					},
				}}
			>
				{//props.products > 0 ? 

					props.products.map((Data, key) => {

						return (
							<SwiperSlide key={key + '-swipper'}>
								<div className="cate-bx text-center">
									<div className="card" style={{marginBottom: 20}}>
										<div
											style={{
												boxShadow: '2px 2px 2px #f1f1f1',
												backgroundColor: 'white',
												minHeight: 460
											}}>
											<span style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
												{Data.images.length > 0 ?
													<img className="" style={{ width: '100%' }} src={'https://core.pskeromais.com.br/' + Data.images[0].url} />
													: <span style={{
														width: '100%',
														height: 120,
														backgroundImage: "gray",
														margin: '0 auto',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center', gap: 2, backgroundColor: 'rgb(241 241 241)'
													}}>
														<i className='bi bi-gift' style={{ fontSize: 45, color: 'white' }} />
													</span>
												}
												<span className="mb-0 fs--1" style={{ width: '100%', textAlign: 'center' , fontSize: 10 }}>pack com 10 unid. </span>
												<div className="d-flex align-items-center" style={{width: '100%' , justifyContent: 'center'}}>
													<div>
														<br />
														<div className="d-flex" style={{justifyContent: 'center', width: '100%' , flexDirection: 'column'}}>
															<h4 style={{textAlign: 'center' , width: '100%' }}>
																{Data.name}
															</h4>
															<span style={{fontSize: '12px' , fontWeight: 'bold' , margin: '4px auto' , display: 'block' , textAlign: 'center'}}>
                                                                { 
                                                                    Data.categoryId === "54bd475f-7438-49fb-9967-ef0d2ba32c46"?
                                                                    'Salgadinho de Milho'
                                                                    :Data.categoryId === "219cbfd3-dc40-4547-ba16-b68ee3cbb758"?
                                                                    'Salgadinho de Trigo'
                                                                    :Data.categoryId === "d34e4917-4cdb-442e-90e8-e68adc781807"?
                                                                    'Pipoca'
                                                                    :null
                                                                }
                                                            </span> 
														</div>
													</div>
												</div>
												{/* <span style={{ display: 'flex', flexDirection: 'column', gap: 4 }}> */}
													<div style={{ display: 'flex', gap: 4, flexDirection: 'row', justifyContent: 'center' , flexWrap: 'wrap'}}>
                                                        <span style={{position: 'relative'}}>
                                                            <label style={{ fontSize: 10 }}>preço</label>
                                                            <span style={{  backgroundColor: 'rgb(241, 241, 241)', padding: 3, borderRadius: '3px', display: 'flex', justifyContent: 'center' }}>
                                                                <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{Data.onSalePrice.toFixed(2) + ' R$'}</span>
                                                            </span>
															{Data.salePrice > Data.onSalePrice ? (
																<span style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontWeight: 'bold', backgroundColor: '#F54749', color: 'white', width: 60, height: 60, padding: 10, borderRadius: '100%', fontSize: 18, position: 'absolute', top: '6px', right: '-60px' }}>
																	<span style={{ height: '14px' }}>{calculateDiscountPercentage(Data.salePrice, Data.onSalePrice) + '%'}</span>
																	<span style={{ height: '14px', fontWeight: 'normal' }}>OFF</span>
																</span>
															) : null}
                                                        </span>
                                                        {/* <span>
                                                            <label style={{ fontSize: 10 }}>estoque</label>
                                                            <span style={{ padding: 3, borderRadius: '3px', backgroundColor: 'rgb(241, 241, 241)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{Data.stock}</span>
                                                            </span>
                                                        </span> */}
                                                    </div>
													{props.isBuying ?
                                                    <div style={{ textAlign: 'center', width: "100%", display: 'flex', flexDirection: 'row', gap: 3, justifyContent: 'center', alignItems: 'center' }}>
                                                        <button onClick={() => props.qtfcrMinus(Data)} className="btn btn-primary d-flex justify-content-center align-items-center white d-flex p-1 px-2 mt-2 mr-auto ml-auto" style={{ fontSize: 11, width: 30, height: 30 }}>
                                                            <i className="bi bi-dash" style={{ fontSize: 20 }}></i>
                                                        </button>
                                                        <span style={{ 
                                                            minWidth: 36, 
                                                            minHeight: 36, 
                                                            width: 38, 
                                                            height: 38, 
                                                            display: 'flex', 
                                                            alignItems: 'center', 
                                                            justifyContent: 'center', 
                                                            borderRadius: '50%', 
                                                            background: '#e0e0e0', 
                                                            fontWeight: 'bold', 
                                                            fontSize: 22, 
                                                            color: '#333',
                                                            margin: '0 6px',
                                                            border: '2px solid #bdbdbd',
                                                        }}>{getQtd(Data)}</span>
                                                        <button onClick={() => props.qtfcrPlus(Data)} className="btn btn-secondary d-flex justify-content-center align-items-center white d-flex p-1 px-2 mt-2 mr-auto ml-auto" style={{ fontSize: 11, width: 30, height: 30 }}>
                                                            <i className="bi bi-plus" style={{ fontSize: 20 }}></i>
                                                        </button>
                                                    </div>
                                                    : <div style={{ textAlign: 'center', width: "100%", display: 'flex', flexDirection: 'row', gap: 3, justifyContent: 'center', alignItems: 'center' }}>
                                                        <button onClick={() => props.setModalShows()} className="btn btn-secondary d-flex justify-content-center align-items-center white d-flex p-1 px-2 mt-2 mr-auto ml-auto">
                                                            fazer pedido
                                                        </button>
                                                    </div>}
												{/* </span> */}
											</span>
										</div>
									</div>
								</div>
							</SwiperSlide>
						)

					})
					//: ''}
				}
				<div className="swiper-pagination"></div>
			</Swiper>
		</>
	)
}
export default SwiperCTNProducts;
